import React, { useState, useEffect } from 'react';
import axios from 'axios';

const COLORES_UNICA = [
  { label: 'Verde', hex: '#CCFFCC' },
  { label: 'Naranja', hex: '#FFCC99' },
  { label: 'Amarillo', hex: '#FFFF00' },
  { label: 'Rosa', hex: '#F75EBD' },
  { label: 'Lila', hex: '#CC99FF' },
  { label: 'Azul', hex: '#3399FF' },
  { label: 'Celeste', hex: '#CCFFFF' },
  { label: 'Sin color', hex: '' },
];

function Admin() {
  const [seccion, setSeccion] = useState('productos');

  const [productos, setProductos] = useState([]);
  const [busquedaProd, setBusquedaProd] = useState('');
  const [formProducto, setFormProducto] = useState({ nombre: '', codigo_barras: '', codigo_interno: '', vacio_id: '', se_pesa: false });
  const [mostrarFormProd, setMostrarFormProd] = useState(false);
  const [editandoProducto, setEditandoProducto] = useState(null);
  const [editandoProveedor, setEditandoProveedor] = useState(null);

  const [proveedores, setProveedores] = useState([]);
  const [busquedaProv, setBusquedaProv] = useState('');
  const [formProveedor, setFormProveedor] = useState({ nombre: '', codigo_sistema: '', contacto: '', telefono: '' });
  const [mostrarFormProv, setMostrarFormProv] = useState(false);

  const [vacios, setVacios] = useState([]);
  const [busquedaVacio, setBusquedaVacio] = useState('');
  const [formVacio, setFormVacio] = useState({ nombre: '', codigo_barras: '', codigo_interno: '', precio: '' });
  const [mostrarFormVacio, setMostrarFormVacio] = useState(false);
  const [editandoPrecio, setEditandoPrecio] = useState({});
  const [editandoNombreVacio, setEditandoNombreVacio] = useState({});

  const [usuarios, setUsuarios] = useState([]);
  const [mostrarFormUsuario, setMostrarFormUsuario] = useState(false);
  const [formUsuario, setFormUsuario] = useState({ nombre: '', email: '', password: '', rol: '' });
  const [editandoPassword, setEditandoPassword] = useState({});

  const [asignandoVacio, setAsignandoVacio] = useState(null);
  const [vacioSeleccionado, setVacioSeleccionado] = useState('');
  const [busquedaVacioAsign, setBusquedaVacioAsign] = useState('');
  const [vaciosAsign, setVaciosAsign] = useState([]);
  const [mostrarListaVacio, setMostrarListaVacio] = useState(false);

  const [limiteProd, setLimiteProd] = useState(50);
  const [limiteProv, setLimiteProv] = useState(50);
  const [limiteVacio, setLimiteVacio] = useState(50);

  // Lista Única
  const [productosUnica, setProductosUnica] = useState([]);
  const [busquedaUnica, setBusquedaUnica] = useState('');
  const [editandoVtaUnica, setEditandoVtaUnica] = useState({});
  const [editandoColorUnica, setEditandoColorUnica] = useState({});
  const [guardandoUnica, setGuardandoUnica] = useState({});

  const [analisisPesaje, setAnalisisPesaje] = useState([]);
  const [mostrarAnalisisPesaje, setMostrarAnalisisPesaje] = useState(false);
  const [seleccionPesaje, setSeleccionPesaje] = useState({});
  const [cargandoPesaje, setCargandoPesaje] = useState(false);

  const [mensaje, setMensaje] = useState('');
  const token = localStorage.getItem('token');

  const mostrarMensaje = (msg) => {
    setMensaje(msg);
    setTimeout(() => setMensaje(''), 3000);
  };

  const cargarProductos = async (busqueda = '') => {
    const res = await axios.get(`https://comprasmercadomodelo.online/api/admin/productos?busqueda=${encodeURIComponent(busqueda)}`, { headers: { authorization: token } });
    setProductos(res.data);
  };

  const cargarAnalisisPesaje = async () => {
    setCargandoPesaje(true);
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/admin/analisis-pesaje', { headers: { authorization: token } });
      setAnalisisPesaje(res.data);
      const sel = {};
      res.data.forEach(p => {
        if (Number(p.veces_con_peso) > 0 && !p.se_pesa) sel[p.id] = true;
      });
      setSeleccionPesaje(sel);
      setMostrarAnalisisPesaje(true);
    } catch (err) {
      mostrarMensaje('❌ Error al cargar el análisis');
    }
    setCargandoPesaje(false);
  };

  const aplicarPesaje = async () => {
    const ids = Object.keys(seleccionPesaje).filter(id => seleccionPesaje[id]).map(Number);
    if (ids.length === 0) {
      mostrarMensaje('No seleccionaste ningún producto');
      return;
    }
    try {
      const res = await axios.post('https://comprasmercadomodelo.online/api/admin/aplicar-pesaje', { ids }, { headers: { authorization: token } });
      mostrarMensaje(`✅ ${res.data.mensaje}`);
      setMostrarAnalisisPesaje(false);
      cargarProductos(busquedaProd);
    } catch (err) {
      mostrarMensaje('❌ Error al aplicar el marcado');
    }
  };

  const cargarProveedores = async (busqueda = '') => {
    const res = await axios.get(`https://comprasmercadomodelo.online/api/admin/proveedores?busqueda=${encodeURIComponent(busqueda)}`, { headers: { authorization: token } });
    setProveedores(res.data);
  };

  const cargarVacios = async (busqueda = '') => {
    const res = await axios.get(`https://comprasmercadomodelo.online/api/admin/vacios?busqueda=${encodeURIComponent(busqueda)}`, { headers: { authorization: token } });
    setVacios(res.data);
  };

  const cargarUsuarios = async () => {
    const res = await axios.get('https://comprasmercadomodelo.online/api/admin/usuarios', { headers: { authorization: token } });
    setUsuarios(res.data);
  };

  const cargarProductosUnica = async (busqueda = '') => {
    const res = await axios.get(`https://comprasmercadomodelo.online/api/admin/productos?busqueda=${encodeURIComponent(busqueda)}`, { headers: { authorization: token } });
    setProductosUnica(res.data);
    const colores = {};
    res.data.forEach(p => { colores[p.id] = p.color_fondo || ''; });
    setEditandoColorUnica(colores);
  };

  useEffect(() => {
    if (seccion === 'productos') cargarProductos();
    if (seccion === 'proveedores') cargarProveedores();
    if (seccion === 'vacios') cargarVacios();
    if (seccion === 'usuarios') cargarUsuarios();
    if (seccion === 'unica') cargarProductosUnica();
  }, [seccion]);

  const guardarProducto = async (e) => {
    e.preventDefault();
    await axios.post('https://comprasmercadomodelo.online/api/admin/productos', formProducto, { headers: { authorization: token } });
    setFormProducto({ nombre: '', codigo_barras: '', codigo_interno: '' });
    setMostrarFormProd(false);
    cargarProductos(busquedaProd);
    mostrarMensaje('✅ Producto creado correctamente');
  };

  const guardarEdicionProducto = async () => {
    await axios.put(`https://comprasmercadomodelo.online/api/admin/productos/${editandoProducto.id}`,
      { nombre: editandoProducto.nombre, codigo_barras: editandoProducto.codigo_barras, vacio_id: editandoProducto.vacio_id, se_pesa: editandoProducto.se_pesa },
      { headers: { authorization: token } }
    );
    setEditandoProducto(null);
    cargarProductos(busquedaProd);
    mostrarMensaje('✅ Producto actualizado correctamente');
  };

  const eliminarProducto = async (id) => {
    if (!window.confirm('¿Eliminar este producto? Esta acción no se puede deshacer.')) return;
    await axios.delete(`https://comprasmercadomodelo.online/api/admin/productos/${id}`, { headers: { authorization: token } });
    cargarProductos(busquedaProd);
    mostrarMensaje('✅ Producto eliminado');
  };
  const guardarEdicionProveedor = async () => {
    await axios.put(`https://comprasmercadomodelo.online/api/admin/proveedores/${editandoProveedor.id}`,
      { nombre: editandoProveedor.nombre, codigo_sistema: editandoProveedor.codigo_sistema, contacto: editandoProveedor.contacto, telefono: editandoProveedor.telefono },
      { headers: { authorization: token } });
    setEditandoProveedor(null);
    cargarProveedores(busquedaProv);
    mostrarMensaje("Proveedor actualizado");
  };
  const eliminarProveedor = async (id) => {
    if (!window.confirm("¿Eliminar este proveedor? Esta acción no se puede deshacer.")) return;
    try {
      await axios.delete(`https://comprasmercadomodelo.online/api/admin/proveedores/${id}`, { headers: { authorization: token } });
      cargarProveedores(busquedaProv);
      mostrarMensaje("Proveedor eliminado");
    } catch (err) {
      mostrarMensaje("No se puede eliminar: tiene compras asociadas");
    }
  };

  const buscarVaciosAsign = async (texto) => {
    setBusquedaVacioAsign(texto);
    if (texto.length < 2) { setVaciosAsign([]); setMostrarListaVacio(false); return; }
    const res = await axios.get(`https://comprasmercadomodelo.online/api/admin/vacios?busqueda=${encodeURIComponent(texto)}`, { headers: { authorization: token } });
    setVaciosAsign(res.data);
    setMostrarListaVacio(true);
  };

  const asignarVacio = async (productoId) => {
    await axios.put(`https://comprasmercadomodelo.online/api/admin/productos/${productoId}/vacio`,
      { vacio_id: vacioSeleccionado },
      { headers: { authorization: token } }
    );
    setAsignandoVacio(null);
    setVacioSeleccionado('');
    setBusquedaVacioAsign('');
    cargarProductos(busquedaProd);
    mostrarMensaje('✅ Vacío asignado correctamente');
  };

  const guardarProveedor = async (e) => {
    e.preventDefault();
    await axios.post('https://comprasmercadomodelo.online/api/admin/proveedores', formProveedor, { headers: { authorization: token } });
    setFormProveedor({ nombre: '', codigo_sistema: '', contacto: '', telefono: '' });
    setMostrarFormProv(false);
    cargarProveedores(busquedaProv);
    mostrarMensaje('✅ Proveedor creado correctamente');
  };

  const guardarVacio = async (e) => {
    e.preventDefault();
    await axios.post('https://comprasmercadomodelo.online/api/admin/vacios', formVacio, { headers: { authorization: token } });
    setFormVacio({ nombre: '', codigo_barras: '', codigo_interno: '', precio: '' });
    setMostrarFormVacio(false);
    cargarVacios(busquedaVacio);
    mostrarMensaje('✅ Vacío creado correctamente');
  };

  const actualizarPrecioVacio = async (id, precio) => {
    await axios.put(`https://comprasmercadomodelo.online/api/admin/vacios/${id}/precio`,
      { precio }, { headers: { authorization: token } }
    );
    setEditandoPrecio({});
    cargarVacios(busquedaVacio);
    mostrarMensaje('✅ Precio actualizado correctamente');
  };

  const guardarEdicionVacio = async (id, nombre, precio) => {
    await axios.put(`https://comprasmercadomodelo.online/api/admin/vacios/${id}`,
      { nombre, precio }, { headers: { authorization: token } }
    );
    setEditandoPrecio({});
    setEditandoNombreVacio({});
    cargarVacios(busquedaVacio);
    mostrarMensaje("✅ Vacío actualizado correctamente");
  };

  const eliminarVacio = async (id) => {
    if (!window.confirm("¿Eliminar este vacío? Esta acción no se puede deshacer.")) return;
    try {
      await axios.delete(`https://comprasmercadomodelo.online/api/admin/vacios/${id}`, { headers: { authorization: token } });
      cargarVacios(busquedaVacio);
      mostrarMensaje("✅ Vacío eliminado correctamente");
    } catch (err) {
      mostrarMensaje("❌ " + (err.response?.data?.error || "No se pudo eliminar"));
    }
  };

  const guardarUsuario = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://comprasmercadomodelo.online/api/admin/usuarios', formUsuario, { headers: { authorization: token } });
      setFormUsuario({ nombre: '', email: '', password: '', rol: '' });
      setMostrarFormUsuario(false);
      cargarUsuarios();
      mostrarMensaje('✅ Usuario creado correctamente');
    } catch (err) {
      mostrarMensaje('❌ Error al crear usuario — el email puede estar en uso');
    }
  };

  const eliminarUsuario = async (id) => {
    if (!window.confirm('¿Eliminar este usuario?')) return;
    await axios.delete(`https://comprasmercadomodelo.online/api/admin/usuarios/${id}`, { headers: { authorization: token } });
    cargarUsuarios();
    mostrarMensaje('✅ Usuario eliminado');
  };

  const actualizarPasswordUsuario = async (id) => {
    const password = editandoPassword[id];
    if (!password) return;
    await axios.put(`https://comprasmercadomodelo.online/api/admin/usuarios/${id}/password`,
      { password }, { headers: { authorization: token } }
    );
    setEditandoPassword({});
    mostrarMensaje('✅ Contraseña actualizada');
  };

  const guardarPrecioVtaUnica = async (id, precio_venta, color_fondo) => {
    setGuardandoUnica(g => ({ ...g, [id]: true }));
    try {
      await axios.put(`https://comprasmercadomodelo.online/api/admin/productos/${id}`,
        { precio_venta: precio_venta || null, color_fondo: color_fondo || null },
        { headers: { authorization: token } }
      );
      mostrarMensaje('✅ Guardado');
    } catch (err) {
      mostrarMensaje('❌ Error al guardar');
    }
    setGuardandoUnica(g => ({ ...g, [id]: false }));
  };

  const productosFiltrados = productos.slice(0, limiteProd);
  const proveedoresFiltrados = proveedores.slice(0, limiteProv);
  const vaciosFiltrados = vacios.slice(0, limiteVacio);

  const productosUnicaFiltrados = busquedaUnica
    ? productosUnica.filter(p => p.nombre.toLowerCase().includes(busquedaUnica.toLowerCase()) || p.codigo_barras?.toString().includes(busquedaUnica))
    : productosUnica;

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>⚙️ Administración</h3>

      {mensaje && <div style={styles.mensajeBox}>{mensaje}</div>}

      <div style={styles.tabs}>
        {['productos', 'proveedores', 'vacios', 'usuarios', 'unica'].map(tab => (
          <button key={tab} style={{ ...styles.tab, ...(seccion === tab ? styles.tabActivo : {}) }}
            onClick={() => setSeccion(tab)}>
            {tab === 'productos' && '📦 Productos'}
            {tab === 'proveedores' && '🏪 Proveedores'}
            {tab === 'vacios' && '🧺 Vacíos'}
            {tab === 'usuarios' && '👤 Usuarios'}
            {tab === 'unica' && '📋 Lista Única'}
          </button>
        ))}
      </div>

      {/* PRODUCTOS */}
      {seccion === 'productos' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar por nombre o código..."
              value={busquedaProd}
              onChange={(e) => { setBusquedaProd(e.target.value); setLimiteProd(50); cargarProductos(e.target.value); }} />
            <span style={styles.contador}>{productosFiltrados.length} de {productos.length}</span>
            <button style={styles.botonNuevo} onClick={() => setMostrarFormProd(!mostrarFormProd)}>
              {mostrarFormProd ? '✕ Cancelar' : '+ Nuevo Producto'}
            </button>
            <button style={{ ...styles.botonNuevo, backgroundColor: '#8e44ad' }} onClick={cargarAnalisisPesaje} disabled={cargandoPesaje}>
              {cargandoPesaje ? 'Analizando...' : '📊 Analizar pesaje (desde Descarga)'}
            </button>
          </div>

          {mostrarFormProd && (
            <div style={styles.formulario}>
              <h4 style={styles.tituloForm}>Nuevo Producto</h4>
              <form onSubmit={guardarProducto}>
                <div style={styles.fila}>
                  <div style={styles.campo}>
                    <label style={styles.label}>Nombre</label>
                    <input style={styles.input} type="text" placeholder="Nombre del producto"
                      value={formProducto.nombre}
                      onChange={(e) => setFormProducto({ ...formProducto, nombre: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Código de barras</label>
                    <input style={styles.input} type="number" placeholder="Código"
                      value={formProducto.codigo_barras}
                      onChange={(e) => setFormProducto({ ...formProducto, codigo_barras: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Código interno</label>
                    <input style={styles.input} type="text" placeholder="CDI-XXXXX"
                      value={formProducto.codigo_interno}
                      onChange={(e) => setFormProducto({ ...formProducto, codigo_interno: e.target.value })} />
                  </div>
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Vacío</label>
                  <select style={styles.input}
                    value={formProducto.vacio_id}
                    onChange={(e) => setFormProducto({ ...formProducto, vacio_id: e.target.value })}>
                    <option value="">Sin vacío</option>
                    {vacios.map(v => (
                      <option key={v.id} value={v.id}>{v.nombre}</option>
                    ))}
                  </select>
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>
                    <input type="checkbox" checked={formProducto.se_pesa}
                      onChange={(e) => setFormProducto({ ...formProducto, se_pesa: e.target.checked })} />
                    {" "}Se pesa (por kg)
                  </label>
                </div>
                <button style={styles.botonGuardar} type="submit">💾 Guardar</button>
              </form>
            </div>
          )}

          {editandoProducto && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h4 style={styles.modalTitulo}>✏️ Editar Producto</h4>
                <div style={styles.campo}>
                  <label style={styles.label}>Nombre</label>
                  <input style={styles.input} type="text"
                    value={editandoProducto.nombre}
                    onChange={(e) => setEditandoProducto({ ...editandoProducto, nombre: e.target.value })} />
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Código de barras</label>
                  <input style={styles.input} type="text"
                    value={editandoProducto.codigo_barras}
                    onChange={(e) => setEditandoProducto({ ...editandoProducto, codigo_barras: e.target.value })} />
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Vacío</label>
                  <select style={styles.input}
                    value={editandoProducto.vacio_id || ''}
                    onChange={(e) => setEditandoProducto({ ...editandoProducto, vacio_id: e.target.value || null })}>
                    <option value="">Sin vacío</option>
                    {vacios.map(v => (
                      <option key={v.id} value={v.id}>{v.nombre} — ${Number(v.precio).toLocaleString('es-AR')}</option>
                    ))}
                  </select>
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>
                    <input type="checkbox" checked={!!editandoProducto.se_pesa}
                      onChange={(e) => setEditandoProducto({ ...editandoProducto, se_pesa: e.target.checked })} />
                    {" "}Se pesa (por kg)
                  </label>
                </div>
                <div style={styles.modalBotones}>
                  <button style={styles.botonGuardar} onClick={guardarEdicionProducto}>💾 Guardar</button>
                  <button style={styles.botonCancelarPeq} onClick={() => setEditandoProducto(null)}>✕ Cancelar</button>
                </div>
              </div>
            </div>
          )}

          {mostrarAnalisisPesaje && (
            <div style={styles.modalOverlay}>
              <div style={{ ...styles.modal, maxWidth: '800px', maxHeight: '85vh', overflowY: 'auto' }}>
                <h4 style={styles.modalTitulo}>📊 Análisis de pesaje (según Descarga)</h4>
                <p style={{ fontSize: '13px', color: '#7f8c8d', marginBottom: '15px' }}>
                  Se muestran los productos que tuvieron peso cargado en Descarga alguna vez. Vienen tildados los que todavía no están marcados como "Se pesa" pero tuvieron peso. Revisá y confirmá.
                </p>
                {analisisPesaje.length === 0 ? (
                  <div>No hay datos de descarga todavía.</div>
                ) : (
                  <table style={styles.tableEl}>
                    <thead>
                      <tr style={styles.thead}>
                        <th style={styles.th}></th>
                        <th style={styles.th}>Producto</th>
                        <th style={styles.th}>Veces descargado</th>
                        <th style={styles.th}>Veces con peso</th>
                        <th style={styles.th}>Ya marcado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {analisisPesaje.map(p => (
                        <tr key={p.id} style={styles.tr}>
                          <td style={styles.td}>
                            <input type="checkbox" checked={!!seleccionPesaje[p.id]}
                              onChange={(e) => setSeleccionPesaje({ ...seleccionPesaje, [p.id]: e.target.checked })} />
                          </td>
                          <td style={styles.td}>{p.nombre}</td>
                          <td style={styles.td}>{p.veces_descargado}</td>
                          <td style={styles.td}>{p.veces_con_peso}</td>
                          <td style={styles.td}>{p.se_pesa ? '✅' : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                <div style={styles.modalBotones}>
                  <button style={styles.botonGuardar} onClick={aplicarPesaje}>💾 Marcar seleccionados como "Se pesa"</button>
                  <button style={styles.botonCancelarPeq} onClick={() => setMostrarAnalisisPesaje(false)}>✕ Cerrar</button>
                </div>
              </div>
            </div>
          )}

          {editandoProveedor && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h4 style={styles.modalTitulo}>Editar Proveedor</h4>
                <div style={styles.campo}>
                  <label style={styles.label}>Nombre</label>
                  <input style={styles.input} type="text"
                    value={editandoProveedor.nombre}
                    onChange={(e) => setEditandoProveedor({ ...editandoProveedor, nombre: e.target.value })} />
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Codigo sistema</label>
                  <input style={styles.input} type="text"
                    value={editandoProveedor.codigo_sistema}
                    onChange={(e) => setEditandoProveedor({ ...editandoProveedor, codigo_sistema: e.target.value })} />
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Contacto</label>
                  <input style={styles.input} type="text"
                    value={editandoProveedor.contacto || ""}
                    onChange={(e) => setEditandoProveedor({ ...editandoProveedor, contacto: e.target.value })} />
                </div>
                <div style={styles.campo}>
                  <label style={styles.label}>Telefono</label>
                  <input style={styles.input} type="text"
                    value={editandoProveedor.telefono || ""}
                    onChange={(e) => setEditandoProveedor({ ...editandoProveedor, telefono: e.target.value })} />
                </div>
                <div style={styles.modalBotones}>
                  <button style={styles.botonGuardar} onClick={guardarEdicionProveedor}>Guardar</button>
                  <button style={styles.botonCancelarPeq} onClick={() => setEditandoProveedor(null)}>Cancelar</button>
                </div>
              </div>
            </div>
          )}
          <div style={styles.tabla}>
            <table style={styles.tableEl}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>Código</th>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Cód. Interno</th>
                  <th style={styles.th}>Vacío asignado</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {productosFiltrados.map(p => (
                  <tr key={p.id} style={styles.tr}>
                    <td style={styles.tdCodigo}>{p.codigo_barras}</td>
                    <td style={styles.td}>{p.nombre}</td>
                    <td style={styles.td}>{p.codigo_interno}</td>
                    <td style={styles.td}>
                      {asignandoVacio === p.id ? (
                        <div style={{ position: 'relative' }}>
                          <input style={styles.inputBuscar} type="text"
                            placeholder="Buscar vacío..."
                            value={busquedaVacioAsign}
                            onChange={(e) => buscarVaciosAsign(e.target.value)}
                            onBlur={() => setTimeout(() => setMostrarListaVacio(false), 200)}
                            autoFocus />
                          {mostrarListaVacio && vaciosAsign.length > 0 && (
                            <div style={styles.desplegable}>
                              {vaciosAsign.map(v => (
                                <div key={v.id} style={styles.opcion}
                                  onMouseDown={() => {
                                    setVacioSeleccionado(v.id);
                                    setBusquedaVacioAsign(v.nombre);
                                    setMostrarListaVacio(false);
                                  }}>
                                  {v.nombre} — ${Number(v.precio).toLocaleString('es-AR')}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        p.vacio_nombre ?
                          <span style={styles.vacioAsignado}>🧺 {p.vacio_nombre}</span> :
                          <span style={styles.sinVacio}>⚠️ Sin vacío</span>
                      )}
                    </td>
                    <td style={styles.td}>
                      {asignandoVacio === p.id ? (
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <button style={styles.botonGuardarPeq} onClick={() => asignarVacio(p.id)}>✓</button>
                          <button style={styles.botonCancelarPeq} onClick={() => { setAsignandoVacio(null); setBusquedaVacioAsign(''); }}>✕</button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                          <button style={styles.botonEditar} onClick={() => { setEditandoProducto({ ...p }); cargarVacios(); }}>✏️ Editar</button>
                          <button style={styles.botonEditar} onClick={() => { setAsignandoVacio(p.id); setBusquedaVacioAsign(p.vacio_nombre || ''); setVacioSeleccionado(''); }}>🧺 Vacío</button>
                          <button style={styles.botonEliminar} onClick={() => eliminarProducto(p.id)}>🗑️</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {productos.length > limiteProd && (
            <div style={styles.verMas}>
              <button style={styles.botonVerMas} onClick={() => setLimiteProd(l => l + 50)}>
                ▼ Ver más ({productos.length - limiteProd} restantes)
              </button>
            </div>
          )}
        </div>
      )}

      {/* PROVEEDORES */}
      {seccion === 'proveedores' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar proveedor por nombre..."
              value={busquedaProv}
              onChange={(e) => { setBusquedaProv(e.target.value); setLimiteProv(50); cargarProveedores(e.target.value); }} />
            <span style={styles.contador}>{proveedoresFiltrados.length} de {proveedores.length}</span>
            <button style={styles.botonNuevo} onClick={() => setMostrarFormProv(!mostrarFormProv)}>
              {mostrarFormProv ? '✕ Cancelar' : '+ Nuevo Proveedor'}
            </button>
          </div>

          {mostrarFormProv && (
            <div style={styles.formulario}>
              <h4 style={styles.tituloForm}>Nuevo Proveedor</h4>
              <form onSubmit={guardarProveedor}>
                <div style={styles.fila}>
                  <div style={styles.campo}>
                    <label style={styles.label}>Nombre</label>
                    <input style={styles.input} type="text" placeholder="Nombre completo"
                      value={formProveedor.nombre}
                      onChange={(e) => setFormProveedor({ ...formProveedor, nombre: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Código sistema</label>
                    <input style={styles.input} type="number" placeholder="Código"
                      value={formProveedor.codigo_sistema}
                      onChange={(e) => setFormProveedor({ ...formProveedor, codigo_sistema: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Contacto</label>
                    <input style={styles.input} type="text" placeholder="Nombre contacto"
                      value={formProveedor.contacto}
                      onChange={(e) => setFormProveedor({ ...formProveedor, contacto: e.target.value })} />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Teléfono</label>
                    <input style={styles.input} type="text" placeholder="Teléfono"
                      value={formProveedor.telefono}
                      onChange={(e) => setFormProveedor({ ...formProveedor, telefono: e.target.value })} />
                  </div>
                </div>
                <button style={styles.botonGuardar} type="submit">💾 Guardar</button>
              </form>
            </div>
          )}

          <div style={styles.tabla}>
            <table style={styles.tableEl}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Contacto</th>
                  <th style={styles.th}>Teléfono</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {proveedoresFiltrados.map(p => (
                  <tr key={p.id} style={styles.tr}>
                    <td style={styles.td}>{p.nombre}</td>
                    <td style={styles.td}>{p.contacto || '-'}</td>
                    <td style={styles.td}>{p.telefono || '-'}</td>
                    <td style={styles.td}>
                      <button style={styles.botonEditar} onClick={() => setEditandoProveedor({ ...p })}>Editar</button>
                      <button style={styles.botonEliminar} onClick={() => eliminarProveedor(p.id)}>Eliminar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {proveedores.length > limiteProv && (
            <div style={styles.verMas}>
              <button style={styles.botonVerMas} onClick={() => setLimiteProv(l => l + 50)}>
                ▼ Ver más ({proveedores.length - limiteProv} restantes)
              </button>
            </div>
          )}
        </div>
      )}

      {/* VACÍOS */}
      {seccion === 'vacios' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar vacío por nombre..."
              value={busquedaVacio}
              onChange={(e) => { setBusquedaVacio(e.target.value); setLimiteVacio(50); cargarVacios(e.target.value); }} />
            <span style={styles.contador}>{vaciosFiltrados.length} de {vacios.length}</span>
            <button style={styles.botonNuevo} onClick={() => setMostrarFormVacio(!mostrarFormVacio)}>
              {mostrarFormVacio ? '✕ Cancelar' : '+ Nuevo Vacío'}
            </button>
          </div>

          {mostrarFormVacio && (
            <div style={styles.formulario}>
              <h4 style={styles.tituloForm}>Nuevo Vacío</h4>
              <form onSubmit={guardarVacio}>
                <div style={styles.fila}>
                  <div style={styles.campo}>
                    <label style={styles.label}>Nombre</label>
                    <input style={styles.input} type="text" placeholder="Nombre del vacío"
                      value={formVacio.nombre}
                      onChange={(e) => setFormVacio({ ...formVacio, nombre: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Código de barras</label>
                    <input style={styles.input} type="number" placeholder="Código"
                      value={formVacio.codigo_barras}
                      onChange={(e) => setFormVacio({ ...formVacio, codigo_barras: e.target.value })} />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Código interno</label>
                    <input style={styles.input} type="text" placeholder="CDI-XXXXX"
                      value={formVacio.codigo_interno}
                      onChange={(e) => setFormVacio({ ...formVacio, codigo_interno: e.target.value })} />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Precio $</label>
                    <input style={styles.input} type="number" placeholder="0"
                      value={formVacio.precio}
                      onChange={(e) => setFormVacio({ ...formVacio, precio: e.target.value })} required />
                  </div>
                </div>
                <button style={styles.botonGuardar} type="submit">💾 Guardar</button>
              </form>
            </div>
          )}

          <div style={styles.tabla}>
            <table style={styles.tableEl}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Precio $</th>
                  <th style={styles.th}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {vaciosFiltrados.map(v => (
                  <tr key={v.id} style={styles.tr}>
                    <td style={styles.td}>
                      {editandoPrecio[v.id] !== undefined ? (
                        <input style={styles.inputEditar}
                          value={editandoNombreVacio[v.id] !== undefined ? editandoNombreVacio[v.id] : v.nombre}
                          onChange={(e) => setEditandoNombreVacio({ ...editandoNombreVacio, [v.id]: e.target.value })} />
                      ) : v.nombre}
                    </td>
                    <td style={styles.td}>
                      {editandoPrecio[v.id] !== undefined ? (
                        <input style={styles.inputPrecio} type="number"
                          value={editandoPrecio[v.id]}
                          onChange={(e) => setEditandoPrecio({ ...editandoPrecio, [v.id]: e.target.value })} />
                      ) : (
                        `$${Number(v.precio).toLocaleString('es-AR')}`
                      )}
                    </td>
                    <td style={styles.td}>
                      {editandoPrecio[v.id] !== undefined ? (
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <button style={styles.botonGuardarPeq} onClick={() => guardarEdicionVacio(v.id, editandoNombreVacio[v.id] !== undefined ? editandoNombreVacio[v.id] : v.nombre, editandoPrecio[v.id])}>✓</button>
                          <button style={styles.botonCancelarPeq} onClick={() => { setEditandoPrecio({}); setEditandoNombreVacio({}); }}>✕</button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: '5px' }}>
                          <button style={styles.botonEditar}
                            onClick={() => { setEditandoPrecio({ ...editandoPrecio, [v.id]: v.precio }); setEditandoNombreVacio({ ...editandoNombreVacio, [v.id]: v.nombre }); }}>
                            ✏️ Editar
                          </button>
                          <button style={styles.botonEliminar} onClick={() => eliminarVacio(v.id)}>🗑️</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {vacios.length > limiteVacio && (
            <div style={styles.verMas}>
              <button style={styles.botonVerMas} onClick={() => setLimiteVacio(l => l + 50)}>
                ▼ Ver más ({vacios.length - limiteVacio} restantes)
              </button>
            </div>
          )}
        </div>
      )}

      {/* USUARIOS */}
      {seccion === 'usuarios' && (
        <div>
          <div style={styles.barraAcciones}>
            <button style={styles.botonNuevo} onClick={() => setMostrarFormUsuario(!mostrarFormUsuario)}>
              {mostrarFormUsuario ? '✕ Cancelar' : '+ Nuevo Usuario'}
            </button>
          </div>

          {mostrarFormUsuario && (
            <div style={styles.formulario}>
              <h4 style={styles.tituloForm}>Nuevo Usuario</h4>
              <form onSubmit={guardarUsuario}>
                <div style={styles.fila}>
                  <div style={styles.campo}>
                    <label style={styles.label}>Nombre</label>
                    <input style={styles.input} type="text" placeholder="Nombre completo"
                      value={formUsuario.nombre}
                      onChange={(e) => setFormUsuario({ ...formUsuario, nombre: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Email</label>
                    <input style={styles.input} type="email" placeholder="email@ejemplo.com"
                      value={formUsuario.email}
                      onChange={(e) => setFormUsuario({ ...formUsuario, email: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Contraseña</label>
                    <input style={styles.input} type="password" placeholder="Contraseña"
                      value={formUsuario.password}
                      onChange={(e) => setFormUsuario({ ...formUsuario, password: e.target.value })} required />
                  </div>
                  <div style={styles.campo}>
                    <label style={styles.label}>Rol</label>
                    <select style={styles.input} value={formUsuario.rol}
                      onChange={(e) => setFormUsuario({ ...formUsuario, rol: e.target.value })} required>
                      <option value="">Seleccionar rol...</option>
                      <option value="encargado">Encargado</option>
                      <option value="asistente">Asistente</option>
                      <option value="carga">Carga</option>
                      <option value="descarga">Descarga</option>
                    </select>
                  </div>
                </div>
                <button style={styles.botonGuardar} type="submit">💾 Crear Usuario</button>
              </form>
            </div>
          )}

          <div style={styles.tabla}>
            <table style={styles.tableEl}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Email</th>
                  <th style={styles.th}>Rol</th>
                  <th style={styles.th}>Creado</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map(u => (
                  <tr key={u.id} style={styles.tr}>
                    <td style={styles.td}>{u.nombre}</td>
                    <td style={styles.td}>{u.email}</td>
                    <td style={styles.td}><span style={styles.rolBadge}>{u.rol}</span></td>
                    <td style={styles.td}>{new Date(u.creado_en).toLocaleDateString('es-AR')}</td>
                    <td style={styles.td}>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        {editandoPassword[u.id] !== undefined ? (
                          <>
                            <input style={{ ...styles.inputPrecio, width: '150px' }}
                              type="password" placeholder="Nueva contraseña"
                              value={editandoPassword[u.id]}
                              onChange={(e) => setEditandoPassword({ ...editandoPassword, [u.id]: e.target.value })} />
                            <button style={styles.botonGuardarPeq} onClick={() => actualizarPasswordUsuario(u.id)}>✓</button>
                            <button style={styles.botonCancelarPeq} onClick={() => setEditandoPassword({})}>✕</button>
                          </>
                        ) : (
                          <>
                            <button style={styles.botonEditar}
                              onClick={() => setEditandoPassword({ ...editandoPassword, [u.id]: '' })}>
                              🔑 Cambiar contraseña
                            </button>
                            <button style={{ ...styles.botonCancelarPeq, fontSize: '12px' }}
                              onClick={() => eliminarUsuario(u.id)}>
                              🗑️ Eliminar
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* LISTA ÚNICA */}
      {seccion === 'unica' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar producto..."
              value={busquedaUnica}
              onChange={(e) => setBusquedaUnica(e.target.value)} />
            <span style={styles.contador}>{productosUnicaFiltrados.length} productos</span>
          </div>
          <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '12px' }}>
            Asigná el color de categoría y el precio de venta a cada producto. Guardá fila por fila.
          </div>
          <div style={styles.tabla}>
            <table style={styles.tableEl}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>Código</th>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Color categoría</th>
                  <th style={styles.th}>Precio venta $</th>
                  <th style={styles.th}>Guardar</th>
                </tr>
              </thead>
              <tbody>
                {productosUnicaFiltrados.map(p => (
                  <tr key={p.id} style={{ ...styles.tr, backgroundColor: editandoColorUnica[p.id] || 'white' }}>
                    <td style={styles.tdCodigo}>{p.codigo_barras}</td>
                    <td style={styles.td}>{p.nombre}</td>
                    <td style={styles.td}>
                      <select style={{ ...styles.inputPrecio, width: '110px', backgroundColor: editandoColorUnica[p.id] || 'white' }}
                        value={editandoColorUnica[p.id] || ''}
                        onChange={(e) => setEditandoColorUnica(c => ({ ...c, [p.id]: e.target.value }))}>
                        {COLORES_UNICA.map(c => (
                          <option key={c.hex} value={c.hex} style={{ backgroundColor: c.hex || 'white' }}>{c.label}</option>
                        ))}
                      </select>
                    </td>
                    <td style={styles.td}>
                      <input style={styles.inputPrecio} type="number" placeholder="0"
                        value={editandoVtaUnica[p.id] !== undefined ? editandoVtaUnica[p.id] : (p.precio_venta || '')}
                        onChange={(e) => setEditandoVtaUnica(v => ({ ...v, [p.id]: e.target.value }))} />
                    </td>
                    <td style={styles.td}>
                      <button style={styles.botonGuardarPeq}
                        disabled={guardandoUnica[p.id]}
                        onClick={() => guardarPrecioVtaUnica(
                          p.id,
                          editandoVtaUnica[p.id] !== undefined ? editandoVtaUnica[p.id] : p.precio_venta,
                          editandoColorUnica[p.id]
                        )}>
                        {guardandoUnica[p.id] ? '...' : '✓'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  titulo: { color: '#2c3e50', fontSize: '22px', marginBottom: '20px' },
  mensajeBox: { backgroundColor: '#d5f5e3', border: '1px solid #27ae60', padding: '12px 20px', borderRadius: '8px', marginBottom: '15px', color: '#27ae60', fontWeight: 'bold' },
  tabs: { display: 'flex', gap: '5px', marginBottom: '20px', flexWrap: 'wrap' },
  tab: { padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '14px' },
  tabActivo: { backgroundColor: '#27ae60', color: 'white', border: '1px solid #27ae60' },
  barraAcciones: { display: 'flex', gap: '15px', marginBottom: '15px', alignItems: 'center', flexWrap: 'wrap' },
  buscador: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', flex: 1, maxWidth: '400px' },
  contador: { fontSize: '13px', color: '#7f8c8d' },
  botonNuevo: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  formulario: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  tituloForm: { color: '#2c3e50', marginBottom: '20px' },
  fila: { display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' },
  campo: { flex: 1, display: 'flex', flexDirection: 'column', minWidth: '150px', position: 'relative', marginBottom: '15px' },
  label: { fontSize: '13px', color: '#7f8c8d', marginBottom: '5px' },
  input: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  botonGuardar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '10px 25px', borderRadius: '6px', cursor: 'pointer' },
  tabla: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', overflowX: 'auto' },
  tableEl: { width: '100%', borderCollapse: 'collapse' },
  thead: { backgroundColor: '#2c3e50' },
  th: { color: 'white', padding: '12px 15px', textAlign: 'left', fontSize: '13px' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#2c3e50' },
  tdCodigo: { padding: '12px 15px', fontSize: '12px', color: '#3498db', fontWeight: 'bold' },
  vacioAsignado: { color: '#27ae60', fontSize: '13px' },
  sinVacio: { color: '#e67e22', fontSize: '13px' },
  botonEditar: { backgroundColor: '#f0f0f0', border: '1px solid #ddd', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  botonEliminar: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  botonGuardarPeq: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  botonCancelarPeq: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  inputBuscar: { padding: '6px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', width: '100%' },
  inputPrecio: { padding: '6px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', width: '100px' },
  desplegable: { position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '6px', maxHeight: '200px', overflowY: 'auto', zIndex: 9999, boxShadow: '0 4px 15px rgba(0,0,0,0.2)' },
  opcion: { padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: '13px' },
  rolBadge: { backgroundColor: '#eaf2ff', color: '#2980b9', padding: '3px 10px', borderRadius: '20px', fontSize: '12px' },
  verMas: { textAlign: 'center', padding: '15px' },
  botonVerMas: { backgroundColor: '#f8f9fa', border: '1px solid #ddd', padding: '10px 30px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', color: '#2c3e50' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  modal: { backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '500px' },
  modalTitulo: { color: '#2c3e50', marginBottom: '20px', fontSize: '18px' },
  modalBotones: { display: 'flex', gap: '10px', marginTop: '20px' }
};

export default Admin;
